import React from 'react'

const DropIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
    <g id="next" transform="translate(12) rotate(90)">
      <path id="Path_21731" data-name="Path 21731" d="M204.973,102.891l-10-6,3.8,6-3.8,6Z" transform="translate(-194.973 -96.891)" fill={props.fill}/>
    </g>
  </svg>
)
DropIcon.defaultProps = {
  fill: "#051f5d"
}

export default DropIcon